<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
          <button type="button" class="close" @click="validationErrors = ''" >&times;</button>
          <ul v-show='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='success'>
          {{success}}
        </div>
        <div class='col-lg-12' style='padding:5px 0px 5px 0px;margin: 0px'>
          <div class="form-group input-group" style='margin: 0px'>
            <span class="input-group-addon" style='padding:5px;'>عقود العروض السابقة</span>
            <select @change="changeCustomerOffer(record)" class="form-control" style="padding: 0px" v-model="record">
              <option v-for="offer in contract_offers" :key="offer.id" :value="offer">
                {{ offer.id === 0 ? offer.offer_name : offer.date + ' => ' + offer.offer_name }}
              </option>
            </select>
            <span class="input-group-addon" style="padding:5px; width: 100px;">{{ record.id }}</span>
          </div>
        </div>

        <div :class="record.price_type == 0 ? 'col-lg-8 col-md-8 col-sm-8' : 'col-lg-12 col-md-12 col-sm-12' " style="padding:5px;">
          <div class='col-lg-6 col-sm-6' style='padding:5px;'>
            <label>العرض:</label>
            <select :disabled="record.id > 0" @change="changePriceType(); OpenFreeItemsModal(record.offer_id)" class="form-control" style="padding: 0px" v-model="record.offer_id">
              <option  v-for="offer in offers" v-bind:key="offer.id"  v-bind:value="offer.id">
                {{offer.offer_name}} - {{offer.price}}
              </option>
            </select>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding:5px;'>
            <label>نوع العقد:</label>
            <select :disabled="record.id > 0" @change="changePriceType()" class="form-control" style="padding: 0px" v-model="record.price_type">
              <option  v-for="type in Paytypes" v-bind:key="type.id"  v-bind:value="type.id">
                {{type.name}}
              </option>
            </select>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding:5px;'>
            <label>حالة العقد:</label>
            <select class="form-control" style="padding: 0px" v-model="record.state">
              <option  v-for="type in types" v-bind:key="type.id"  v-bind:value="type.id">
                {{type.name}}
              </option>
            </select>
          </div>
          <div class='col-lg-5 col-md-5 col-sm-5' style='padding:5px;'>
            <label>المفوض:</label>
            <select class="form-control" style="padding: 0px" v-model="record.teller_user_id">
              <option v-for="item in delegates" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-4 col-md-4 col-sm-5' style='padding:5px;'>
            <label>الفنى:</label>
            <select class="form-control" style="padding: 0px" v-model="record.tec_user_id">
              <option v-for="item in technicals" v-bind:key="item.id" v-bind:value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div class='col-lg-3 col-md-3 col-sm-3' style='padding:5px;'>
            <label>تاريخ التعاقد:</label>
            <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.date'></Datepicker>
          </div>
          <div :class="record.price_type == 0 ? 'col-lg-3 col-md-3 col-sm-3': 'col-lg-4 col-md-4 col-sm-4'"  style='padding:5px;'>
            <label>السعر:</label>
            <input  disabled :value='record.price' class='form-control' name='amount' type='text'>
          </div>
          <div :class="record.price_type == 0 ? 'col-lg-3 col-md-3 col-sm-3': 'col-lg-4 col-md-4 col-sm-4'" style='padding:5px;'>
            <label>الخصم:</label>
            <input  @keypress="isNumber($event)" v-on:input='UpdatePrice()' class='form-control' v-model='record.discount' name='discount' type='text'>
          </div>
          <div :class="record.price_type == 0 ? 'col-lg-3 col-md-3 col-sm-3': 'col-lg-4 col-md-4 col-sm-4'" style='padding:5px;'>
            <label>{{inputLable}}:</label>
            <input  disabled class='form-control' :value='record.amount' name='amount' type='text'>
          </div>
          <div v-if="record.price_type == 0" class='col-lg-3 col-sm-3' style='padding:5px;'>
            <label>المقدم:</label>
            <input :disabled="record.price_type == 1"  @keypress="isNumber($event)"  v-on:input='UpdatePrice()' v-model='record.paid' class='form-control' name='amount' type='text'>
          </div>
          <div v-if="record.price_type == 0" class='col-lg-4 col-sm-4' style='padding:5px;'>
            <label>تاريـخ سداد المقدم:</label>
            <div class="form-group input-group" style='margin: 0px'>
              <Datepicker :disabled="record.price_type == 1" :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.presenter_date'></Datepicker>
              <span class="input-group-btn">
                <button class="btn btn-default" @click="inputEmpty()" type="button" style = "color: red;">X</button>
              </span>
            </div>
          </div>
          <div v-if="record.price_type == 0" class='col-lg-4 col-sm-4' style='padding:5px;'>
            <label>الباقى:</label>
            <input :disabled="record.price_type == 1"  @keypress="isLocked($event)" v-model='record.rest' class='form-control' name='amount' type='text'>
          </div>
          <!-- <div class='col-lg-3 col-sm-3' style='padding:5px;'>
          <label>كود العقد:</label>
          <input  @keypress="isNumber($event)" v-model='record.rec_id' class='form-control' name='amount' type='text'>
        </div> -->
        <div v-if="record.price_type == 0" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>فترة السداد:</label>
          <select :disabled="record.price_type == 1" class="form-control" style="padding: 0px" v-model="record.installment_period_monthly">
            <option v-for="item in periodMonthlyType" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div v-if="record.price_type == 0" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>بداية السداد:</label>
          <Datepicker :disabled="record.price_type == 1" :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.installment_data'></Datepicker>
        </div>
        <div v-if="record.price_type == 0" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>عدد الأقساط:</label>
          <select :disabled="record.price_type == 1" class="form-control" style="padding: 0px" v-model="record.installment_count">
            <option v-for="n in 10" :key="n" :value="n">
              {{ n }}
            </option>
          </select>
        </div>
        <div v-if="record.price_type == 0" class='col-lg-4 col-sm-4' style='padding:5px;'>
          <label>قيمة القسط:</label>
          <div class="form-group input-group">
            <span class="input-group-btn">
              <button class="btn btn-default" type="button" @click="calcInstallment();"><i class="fa fa-list-alt"></i>
              </button>
            </span>
            <input :disabled="record.price_type == 1" maxlength="4" @keypress="isNumber($event)" v-model='record.installment' class='form-control text-center' name='installment' type='text'>
          </div>
        </div>
      </div>
      <div v-if = "record.price_type == 0" class='col-lg-4 col-sm-4' style="padding: 0px">
        <div class="chat-panel panel panel-default" style="height: 345px;">
          <div class="panel-heading" style="padding: 5px; text-align: center">
            الأقساط
          </div>
          <div class="panel-body" style="height: 280px;padding: 5px">
            <table class="compact-table">
              <thead>
                <tr>
                  <th>م</th>
                  <th>المبلغ</th>
                  <th>التاريخ</th>
                  <th>الاجراء&nbsp;<i v-if="this.installments.length > 0" class="fa fa-trash-o" style="color: red;" @click="deleteInstallment(-1)"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in installments" v-bind:key="item.id" v-bind:value="item.id">
                  <td>{{index + 1}}</td>
                  <td>{{item.amount}}</td>
                  <td>{{item.due_date}}</td>
                  <td><i class="fa fa-pencil" style="color: blue;"  @click="OpenAddModal(index)"></i>&nbsp;&nbsp;&nbsp;<i class="fa fa-trash-o" style="color: red;" @click="deleteInstallment(index)"></i></td>
                </tr>
                <!-- زود الصفوف حسب الحاجة -->
              </tbody>
            </table>
          </div>
          <div
          class="panel-footer"
          style="padding: 5px; text-align: center"
          :class="{
            'text-red': totalInstalls !== 0,
            'text-green': totalInstalls === 0
            }"
            >
            فرق مبلغ الأقساط = {{ totalInstalls }}
            <div v-if="totalInstalls > 0" class="pull-right">
              <!-- <button v-if="this.installments.length == 0" @click="generateInstallments()" class="btn btn-xs btn-outline btn-success" type="button">توزيع</button> -->
            </div>
            <div v-if="totalInstalls > 0" class="pull-left">
              <!-- <button  @click="OpenAddModal(-1)" class="btn btn-xs btn-outline btn-success" type="button">إضافة</button> -->
            </div>
          </div>
        </div>
      </div>
      <div class='col-lg-12 col-sm-12' style='padding: 10px 0px 0px 0px;'>
        <div class="form-group input-group" style='margin: 0px'>
          <span class="input-group-addon" style='padding:5px;'>ملاحظات:</span>
          <input  v-model='record.notes' class='form-control' name='notes' type='text'>
        </div>
      </div>
      <div class='col-lg-4' style='padding:10px;'>
        <button :disabled="record.offer_id == 0" type='button' @click="showItemsTableModal" class='btn btn-block btn-md btn-info '><i class="fa fa-table"></i> <b>أصناف العرض</b></button>
      </div>
      <div class='col-lg-4' style='padding:10px;'>
        <button v-show="record.id > -1" @click='saveData()'   type='button' class='btn btn-block btn-md btn-success'><i class="fa fa-save"></i> <b>حفظ</b></button>
      </div>
      <div class='col-lg-4' style='padding:10px;'>
        <button :disabled="record.id == 0" @click='deleteData(record)' type='button' class='btn btn-block btn-danger btn-md'><i class="fa fa-trash"></i> <b>حذف</b></button>
      </div>
      <!-- /.col-lg-6 -->
    </div>
  </div>
  <!-- /.container-fluid -->
  <!-- ======================= Add Modale Start -->
  <div v-if="showAddModal" class="custom-centered-modal">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="showAddModal = false">&times;</button>
          <h4 class="modal-title text-center">{{ addModalTitle }}</h4>
        </div>

        <div class="modal-body">
          <div class="form-group input-group">
            <span class="input-group-addon" style='padding:5px;'>المبلغ</span>
            <input  @keypress="isNumber($event)" v-model='installmentRecord.amount' class='form-control' name='amount' type='text'>
          </div>
          <div class="form-group input-group">
            <span class="input-group-addon" style='padding:5px;'>تاريخ الاستحقاق:</span>
            <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='installmentRecord.due_date'></Datepicker>
          </div>
        </div>

        <div class="modal-footer">
          <button @click='saveInstallmentData()'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
          <button class='btn btn-outline btn-sm btn-default' @click="showAddModal = false">إغلاق</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ======================= Add Modale End -->
  <!-- =======================  Items Modale Start -->
  <div v-if="showFreeItemsModal" class="custom-centered-modal">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="showFreeItemsModal = false">&times;</button>
          <h4 class="modal-title text-center">أصناف العقد</h4>
        </div>

        <div class="modal-body">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th style="width: 50px;">#</th>
                <th style="text-align:center;">الصنف</th>
                <th style="width: 120px; text-align:center;">تم التسليم</th>
                <th style="width: 120px; text-align:center;">تم التركيب</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in record.items" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.item }}</td>
                <td class="text-center">
                  <label class="switch">
                    <input type="checkbox" v-model="item.delivered" >
                    <span class="slider round"></span>
                  </label>
                </td>
                <td class="text-center">
                  <label class="switch">
                    <input type="checkbox" v-model="item.changed" >
                    <span class="slider round"></span>
                  </label>
                </td>
              </tr>

              <tr v-if="record.items.length === 0">
                <td colspan="4" class="text-center text-muted">
                  لا يوجد أصناف
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button @click="showFreeItemsModal = false" type='button' class='btn btn-outline btn-sm btn-default'>إغلاق</button>
        </div>
      </div>
    </div>
  </div>
  <!-- =======================  Items Modale End -->
  <!-- =======================  Items After saved Modale Start -->
  <div v-if="showItemsModal" class="custom-centered-modal">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="showItemsModal = false">&times;</button>
          <h4 class="modal-title text-center">أصناف العقد</h4>
        </div>

        <div class="modal-body">
          <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationItemErrors'>
            <button type="button" class="close" @click="validationItemErrors = ''" >&times;</button>
            <ul v-show='validationItemErrors'>
              <li v-for='err in validationItemErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
            </ul>
          </div>

          <div class='col-lg-12' style='padding:5px 0px 5px 0px;margin: 0px'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon"><i class="fa fa-trash-o" style="color: red;" @click="deleteDelivery()"></i>  تسليـم <i class="fa fa-arrow-down" style="color: green;" @click="copyChangeDelivery()"></i></span>
              <select class="form-control" style="padding: 0px;  height: 36px;" v-model="maintenancRec.delivery_technical_id">
                <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
                  {{ technical.name }}
                </option>
              </select>
              <span class="input-group-addon" style="padding:0px; width: 100px;">
                <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='maintenancRec.delivery_date'></Datepicker>
              </span>
            </div>
          </div>

          <div class='col-lg-12' style='padding:5px 0px 5px 0px;margin: 0px'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon"><i class="fa fa-trash-o" style="color: red;" @click="deleteChange()"></i> تغـييــــــــــر </span>
              <select class="form-control" style="padding: 0px;  height: 36px;" v-model="maintenancRec.technical_id">
                <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
                  {{ technical.name }}
                </option>
              </select>
              <span class="input-group-addon" style="padding:0px; width: 100px;">
                <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='maintenancRec.change_date'></Datepicker>
              </span>
            </div>
          </div>

          <div class='col-lg-12' style='padding:5px 0px 5px 0px;margin: 0px'>
            <div class="form-group input-group" style='margin: 0px'>
              <span class="input-group-addon">ملاحــظـــــات</span>
              <input  v-model='maintenancRec.notes' class='form-control' name='notes' type='text'>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-md-offset-4">
              <button :disabled="!maintenancRec.id" @click='saveItemData()'   type='button' class='btn btn-block btn-md btn-success'><i class="fa fa-save"></i> <b>حفظ</b></button>

            </div>
          </div>
          <br>
          <table width='100%' class='table  table-bordered  unselectable' >
            <thead>
              <tr>
                <th style='text-align: center' rowspan=2>م</th>
                <th style='text-align: center' rowspan=2>الصنف</th>
                <th style='text-align: center' colspan=2>تسليم</th>
                <th style='text-align: center' colspan=2>ت التغيير</th>
                <th style='text-align: center' rowspan=2>ملاحظات</th>
              </tr>
              <tr>
                <th style='padding:2px;text-align: center'>الفنى</th>
                <th style='padding:2px;text-align: center'>التاريخ</th>
                <th style='padding:2px;text-align: center'>الفنى</th>
                <th style='padding:2px;text-align: center'>التاريخ</th>
              </tr>
            </thead>
            <tbody>
              <tr :class="{highlight :selectedrec == maintenancRecord.id}"  v-for='(maintenancRecord, index) in maintenancRecords' :key='maintenancRecord.id' v-on:click="setMaintenancRecord(maintenancRecord)">
                <td style="padding:3px" align='center'>{{index + 1}}</td>
                <td style="padding:3px" align='center'>{{maintenancRecord.item}}</td>
                <td style="padding:3px" align='center'>{{maintenancRecord.delivery_technical}}</td>
                <td style="padding:3px" align='center'>{{maintenancRecord.delivery_date}}</td>
                <td style="padding:3px" align='center'>{{maintenancRecord.technical_name}}</td>
                <td style="padding:3px" align='center'>{{maintenancRecord.change_date}}</td>
                <td style="padding:3px" align='right'>{{maintenancRecord.notes}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button @click="showItemsModal = false" type='button' class='btn btn-outline btn-sm btn-default'>إغلاق</button>
        </div>
      </div>
    </div>
  </div>
  <!-- =======================  Items After saved Modale End -->
</div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import API from '@/store/api'
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import Swal from 'sweetalert2'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    tbDate,
    Datepicker
  },
  name: 'Offers',
  // =========================================================================
  watch: {
    'record.items': {
      deep: true,
      handler (items) {
        if (!Array.isArray(items)) return
        items.forEach(item => {
          if (item.changed && !item.delivered) {
            item.delivered = true
          }
          if (!item.delivered && item.changed) {
            item.changed = false
          }
        })
      }
    }
  },
  data () {
    return {
      selectedrec: null,
      showItemsModal: false,
      showFreeItemsModal: false,
      addModalTitle: '',
      ContractOffersBalance: '',
      selectedDelivery: true,
      selectedInstallation: true,
      offerItems: [],
      installmentRecord: [],
      maintenancRec: {},
      totalInstalls: 0,
      ar: ar,
      today: true,
      payDateTitle: 'أول قسط',
      dateTitle: 'التاريخ',
      installmentDateTitle: 'تاريخ القسط',
      validationErrors: '',
      validationItemErrors: '',
      records: {},
      record: {},
      offers: {},
      offer_id: '',
      treasuries: {},
      technicals: {},
      delegates: {},
      contract_offers: {},
      maintenancRecords: {},
      ChangePlans: {},
      installments: [],
      installments2Save: [],
      installmentsFixed: [],
      periodMonthlyType: [{id: null, name: ''}, {id: 1, name: 'شهرى'}, {id: 2, name: 'كل شهرين'}, {id: 3, name: 'كل 3 شهور'}, {id: 4, name: 'كل أربع شهور'}],
      types: [{id: 0, name: 'غير نشط'}, {id: 1, name: 'نشط'}],
      Paytypes: [{id: 0, name: 'قسط'}, {id: 1, name: 'كاش'}, {id: 2, name: 'هدية'}],
      btnTitle: 'عرض الكل',
      success: '',
      isLoadingData: false,
      Localcontract_id: 0,
      isContractOffersLoading: false,
      isOfferRecordsLoading: false,
      showAddModal: false,
      uid: '',
      branch: '',
      inputLable: 'المطلوب'
    }
  },
  methods: {
    // =====================================================
    async pageLoad (id, branch) {
      this.branch = branch
      this.delegates = branch.delegates
      this.technicals = branch.technicals
      this.offers = branch.offers.filter(item => parseInt(item.status) === 1)
      this.isLoadingData = true
      let newRecord = {
        'price': 0,
        'discount': 0,
        'amount': 0,
        'cash_status': 0,
        'date': '',
        'id': 0,
        'items': [],
        'installment': '',
        'installment_data': '',
        'installment_count': 0,
        'installment_period_monthly': '',
        'installments': [],
        'notes': '',
        'offer_id': '',
        'offer_name': '[عرض جديد]',
        'paid': 0,
        'presenter_date': null,
        'price_type': 0,
        'rest': '',
        'state': 1,
        'tec_user_id': '',
        'teller_user_id': ''
      }
      try {
        const data = await API.getCustomerOffers({
          id: id
        })
        if (data.length > 0) {
          this.contract_offers = JSON.parse(JSON.stringify(data))
          this.contract_offers.unshift(JSON.parse(JSON.stringify(newRecord)))
        } else {
          this.contract_offers = []
          this.contract_offers.push(JSON.parse(JSON.stringify(newRecord)))
        }
      } catch (err) {
        this.uid = null
      }
      this.isLoadingData = false
      this.record = this.contract_offers[0]
      this.changeCustomerOffer(this.record)
      this.uid = id
      this.UpdatePrice()
    },
    // =====================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // =====================================================
    isLocked: function (evt) {
      evt.preventDefault()
    },
    // =====================================================
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    // ============================================================
    changeCustomerOffer (rec) {
      if (rec.id === 0) {
        this.setEmptyRec()
      } else {
        this.maintenancRecords = JSON.parse(JSON.stringify(rec.items))
      }
      this.installments = JSON.parse(JSON.stringify(rec.installments))
      this.installments2Save = JSON.parse(JSON.stringify(rec.installments))
      this.installmentsFixed = JSON.parse(JSON.stringify(rec.installments))
      this.calcTotalInstallments()
      for (let i = this.offers.length - 1; i >= 0; i--) {
        if (parseInt(this.offers[i].status) === 0) {
          this.offers.splice(i, 1)
        }
      }
      if (this.record.offer_id > 0) {
        let i = this.offers.findIndex(x => x.id === parseInt(this.record.offer_id))
        if (i === -1) {
          let offer = this.branch.offers.filter(item => parseInt(item.id) === parseInt(this.record.offer_id))
          this.offers.push(JSON.parse(JSON.stringify(offer[0])))
        }
      }
    },
    // ==================================================================
    showItemsTableModal () {
      if (this.record.id > 0) {
        this.showItemsModal = true
      } else {
        this.showFreeItemsModal = true
      }
    },
    // ==================================================================
    changePriceType () {
      let i = this.offers.findIndex(x => x.id === parseInt(this.record.offer_id))
      if (i > -1) {
        if (parseInt(this.record.price_type) === 1) {
          this.inputLable = 'المدفوع'
          this.record.price = this.offers[i].price
          this.record.discount = 0
          this.record.amount = this.offers[i].price
          this.record.paid = this.record.price
          this.record.rest = 0
          this.installments = []
          this.record.installment_period_monthly = null
          this.record.installment = null
          this.record.installment_count = null
          this.record.installment_data = null
          this.totalInstalls = 0
        } else {
          this.inputLable = 'المطلوب'
          this.record.price = this.offers[i].installment_price
          this.record.discount = 0
          this.record.amount = this.offers[i].installment_price
          this.record.paid = 0
          this.record.rest = this.offers[i].installment_price
        }
        this.UpdatePrice()
      }
    },
    // ============================================================
    setEmptyRec () {
      this.contract_offers[0].price = 0
      this.contract_offers[0].discount = 0
      this.contract_offers[0].amount = 0
      this.contract_offers[0].cash_status = 0
      this.contract_offers[0].date = ''
      this.contract_offers[0].id = 0
      this.contract_offers[0].installment = null
      this.contract_offers[0].installment_data = null
      this.contract_offers[0].installment_period_monthly = null
      this.contract_offers[0].installments = []
      this.contract_offers[0].items = []
      this.contract_offers[0].notes = null
      this.contract_offers[0].offer_id = ''
      this.contract_offers[0].paid = 0
      this.contract_offers[0].presenter_date = null
      this.contract_offers[0].installment_count = null
      this.contract_offers[0].price_type = 0
      this.contract_offers[0].rest = 0
      this.contract_offers[0].state = 1
      this.contract_offers[0].tec_user_id = ''
      this.contract_offers[0].teller_user_id = ''
      this.contract_offers[0].rec_id = ''
    },
    // =========================================================================
    setMaintenancRecord (rec) {
      this.selectedrec = rec.id
      this.maintenancRec = { ...rec }
    },
    // =========================================================================
    inputEmpty (id) {
      this.record.presenter_date = null
      this.record.paid = 0
    },
    // ============================================================
    UpdatePrice () {
      if (parseInt(this.record.price || 0) - parseInt(this.record.discount || 0) < 0) {
        this.record.discount = this.record.price
      }
      this.record.amount = parseInt(this.record.price || 0) - parseInt(this.record.discount || 0)
      if (parseInt(this.record.price_type) === 1) {
        this.record.paid = parseInt(this.record.price || 0) - parseInt(this.record.discount || 0)
      } else {
        this.record.rest = parseInt(this.record.amount || 0) - parseInt(this.record.paid || 0)
        this.calcTotalInstallments()
      }
    },
    // ============================================================
    calcTotalInstallments () {
      var totalInstalls = 0
      for (const item of this.installments) {
        totalInstalls += parseInt(item.amount)
      }
      this.totalInstalls = parseInt(this.record.rest || 0) - parseInt(totalInstalls)
    },
    // ============================================================
    generateInstallments () {
      this.validationErrors = []
      var isError = false
      if (parseInt(this.record.price_type) === 0) {
        if (parseInt(this.record.installment) === 0 || this.record.installment === null || this.record.installment === '') {
          this.validationErrors.push('يجب ادخال قيمة القسط')
          isError = true
        }
        if (parseInt(this.record.installment_count) === 0 || this.record.installment_count === null || this.record.installment_count === '') {
          this.validationErrors.push('يجب ادخال عدد الاقساط')
          isError = true
        }
        if (this.record.installment_period_monthly === null || this.record.installment_period_monthly === '') {
          this.validationErrors.push('يجب اختيار فترة السداد')
          isError = true
        }
        if (!moment(this.record.installment_data, 'YYYY-MM-DD', true).isValid()) {
          this.validationErrors.push('يجب ادخال تاريخ بداية السداد')
          isError = true
        }
      }
      if (isError === true) {
        return
      }
      this.validationErrors = ''
      this.installments = []
      const baseDate = moment(this.record.installment_data, 'YYYY-MM-DD')
      for (let i = 0; i < this.record.installment_count; i++) {
        const due = moment(baseDate).add(i * this.record.installment_period_monthly, 'months')
        this.installments.push({
          amount: this.record.installment,
          due_date: due.format('YYYY-MM-DD'),
          type: 0
        })
      }
      this.calcTotalInstallments()
    },
    // ============================================================
    OpenFreeItemsModal (id) {
      if (this.record.offer_id === 0) return
      let i = this.offers.map(record => record.id).indexOf(id)
      if (i > -1) {
        this.record.items = this.offers[i].offer_items.flatMap(item =>
          Array.from({ length: item.item_pieces }, () => ({
            item_id: item.item_id,
            item: item.item,
            delivered: false,
            changed: false
          }))
        )
      }
      this.showFreeItemsModal = true
    },
    // ============================================================
    calcInstallment () {
      if ((this.record.installment_count || 0) > 0) {
        this.record.installment = Math.floor((this.record.rest || 0) / (this.record.installment_count || 0))
      } else {
        this.record.installment = 0
      }
    },
    // ============================================================
    deleteInstallment (id) {
      var text = ''
      if (id === -1) {
        text = 'ستم حذف جميع الأقساط'
      } else {
        text = 'سيتم حذف هذا القسط'
      }
      Swal.fire({
        title: 'هل أنت متأكد',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      })
        .then((result) => {
          if (result.isConfirmed) {
            if (id === -1) {
              this.installments = []
            } else {
              this.installments.splice(id, 1)
            }
            this.calcTotalInstallments()
            Swal.fire({
              position: 'fixed',
              icon: 'success',
              title: 'تم الحذف بنجاح',
              showConfirmButton: false,
              timer: 1000
            })
          }
        })
    },
    // ============================================================
    OpenAddModal (id) {
      this.installmentRecord.id = id
      if (id === -1) {
        this.addModalTitle = 'إضافة قسط'
        this.installmentRecord.due_date = ''
        this.installmentRecord.amount = ''
      } else {
        this.addModalTitle = 'تعديل قسط'
        this.installmentRecord.due_date = this.installments[id].due_date
        this.installmentRecord.amount = this.installments[id].amount
      }
      this.showAddModal = true
    },
    // ============================================================
    saveInstallmentData () {
      let i = this.installments.map(record => record.due_date).indexOf(moment(this.installmentRecord.due_date).format('YYYY-MM-DD'))
      if (i > -1) {
        if (this.installmentRecord.id !== i) {
          Swal.fire({
            position: 'fixed',
            icon: 'error',
            title: 'هذا التاريخ موجود بالفعل في الأقساط.',
            showConfirmButton: false,
            timer: 3000
          })
          return
        }
      }
      if (this.installmentRecord.id === -1) {
        this.installments.push({
          amount: this.installmentRecord.amount,
          due_date: moment(this.installmentRecord.due_date).format('YYYY-MM-DD'),
          paid: 0,
          payment_type: this.record.id,
          type: 0
        })
      } else {
        this.installments[this.installmentRecord.id].due_date = moment(this.installmentRecord.due_date).format('YYYY-MM-DD')
        this.installments[this.installmentRecord.id].amount = this.installmentRecord.amount
      }
      this.calcTotalInstallments()
      this.installments.sort((a, b) => {
        return moment(a.due_date).diff(moment(b.due_date))
      })
      this.showAddModal = false
    },
    // ==================================================================
    async saveData () {
      this.success = ''
      this.validationErrors = []
      var isError = false
      if (parseInt(this.record.offer_id) === 0 || this.record.offer_id === null || this.record.offer_id === '') {
        this.validationErrors.push('يجب اختيار العرض')
        isError = true
      }
      if (parseInt(this.record.teller_user_id) === 0 || this.record.teller_user_id === null || this.record.teller_user_id === '') {
        this.validationErrors.push('يجب اختيار المفوض')
        isError = true
      }
      if (parseInt(this.record.tec_user_id) === 0 || this.record.tec_user_id === null || this.record.tec_user_id === '') {
        this.validationErrors.push('يجب اختيار الفنى')
        isError = true
      }
      if (!moment(this.record.date, 'YYYY-MM-DD', true).isValid()) {
        this.validationErrors.push('يجب ادخال تاريخ التعاقد')
        isError = true
      }
      // ----------------------------
      if (parseInt(this.record.price_type) === 0) {
        if (parseInt(this.record.paid) >= parseInt(this.record.amount)) {
          this.validationErrors.push('يجب ان يكون المدفوع اقل من المبلغ فى العقود القسط')
          isError = true
        }
        if (moment(this.record.presenter_date, 'YYYY-MM-DD', true).isValid()) {
          if (parseInt(this.record.paid) === 0 || this.record.paid === null || this.record.paid === '') {
            this.validationErrors.push('يجب ادخال المبلغ المقدم او حذف تاريخ  سداد المقدم')
            isError = true
          }
        }
        // -------------------------------
        if (parseInt(this.record.paid) > 0) {
          if (!moment(this.record.presenter_date, 'YYYY-MM-DD', true).isValid()) {
            this.validationErrors.push('يجب اختيار تاريخ سداد المقدم')
            isError = true
          }
        }
        if (parseInt(this.record.installment) > parseInt(this.record.rest)) {
          this.validationErrors.push('يجب ان يكون قيمة القسط اقل من المبلغ الباقى')
          isError = true
        }
        if (parseInt(this.record.installment) === 0 || this.record.installment === null || this.record.installment === '') {
          this.validationErrors.push('يجب ادخال قيمة القسط')
          isError = true
        }
        if (parseInt(this.record.installment_count) === 0 || this.record.installment_count === null || this.record.installment_count === '') {
          this.validationErrors.push('يجب ادخال عدد الاقساط')
          isError = true
        }
        if (this.record.installment_period_monthly === null || this.record.installment_period_monthly === '') {
          this.validationErrors.push('يجب اختيار فترة السداد')
          isError = true
        }
        if (!moment(this.record.installment_data, 'YYYY-MM-DD', true).isValid()) {
          this.validationErrors.push('يجب ادخال تاريخ بداية السداد')
          isError = true
        }
      }
      if (isError === true) {
        return
      }
      /*
      this.validationErrors = ''
      if (this.totalInstalls !== 0) {
        this.validationErrors = ['عفوا قيمة الاقساط غير صحيحة']
      } else {
        this.installments2Save = JSON.parse(JSON.stringify(this.installmentsFixed))
        for (const item of this.installments) {
          item.type = 0
        }
        // --------------------------------------
        for (const item of this.installments2Save) {
          let i = this.installments.findIndex(x => x.due_date === item.due_date)
          if (i > -1) {
            if (parseInt(this.installments[i].amount) !== parseInt(item.amount)) {
              item.amount = parseInt(this.installments[i].amount)
              item.type = 1 // update
            }
            this.installments[i].type = 1
          } else {
            item.type = -1
          }
        }
        // --------------------------------------
        for (const item of this.installments) {
          if (item.type === 0) {
            this.installments2Save.push({
              id: 0,
              amount: parseInt(item.amount),
              due_date: item.due_date,
              type: 2 // insert
            })
            item.type = 1 // update
          }
        }
        // -------------------------------------- check total installments
        var totalInstalls = 0
        for (const item of this.installments) {
          totalInstalls += parseInt(item.amount)
        }
        if (parseInt(this.record.rest) !== parseInt(totalInstalls)) {
          this.validationErrors = ['خطأ فى احتساب الأقساط']
        } else {
          this.installments2Save = this.installments2Save.filter(item => item.type !== 0)
          var savedData = JSON.parse(JSON.stringify(this.record))
          savedData.installments = this.installments2Save
          savedData.uid = this.uid
          this.isLoadingData = true
          try {
            const data = await API.saveCustomerOffers(
              savedData
            )
            if (this.record.id === 0) {
              this.contract_offers.push(JSON.parse(JSON.stringify(data)))
              this.record = this.contract_offers[this.contract_offers.length - 1]
              this.changeCustomerOffer(this.record)
            }
            this.success = 'تم الحفظ بنجاح'
          } catch (err) {
            this.validationErrors = err.errors
          }
          this.isLoadingData = false
        }
      }
      */
      // =  حذف بالكامل عند تشغيل السابق من بداية=============
      var savedData = JSON.parse(JSON.stringify(this.record))
      this.validationErrors = ''
      savedData.uid = this.uid
      this.isLoadingData = true
      try {
        const data = await API.saveCustomerOffers(
          savedData
        )
        this.$emit('return-data', data.totals.balance, data.data.customer_id)
        if (this.record.id === 0) {
          this.contract_offers.push(JSON.parse(JSON.stringify(data.data)))
          this.record = this.contract_offers[this.contract_offers.length - 1]
          this.changeCustomerOffer(this.record)
        }
        Swal.fire({
          position: 'fixed',
          icon: 'success',
          title: 'تم حفظ السجل بنجاح',
          showConfirmButton: false,
          timer: 1000
        })
      } catch (err) {
        this.validationErrors = err.errors
      }
      this.isLoadingData = false
      // == آخر الحذف ========================
    },
    /*
|--------------------------------------------------------------------------
| *** Contract Items Model ***********
|--------------------------------------------------------------------------
*/
    deleteDelivery () {
      this.maintenancRec.delivery_date = null
      this.maintenancRec.delivery_technical_id = null
      this.maintenancRec.change_date = null
      this.maintenancRec.technical_id = null
    },
    // =======================================================================
    deleteChange () {
      this.maintenancRec.change_date = null
      this.maintenancRec.technical_id = null
    },
    // =======================================================================
    copyChangeDelivery () {
      this.maintenancRec.technical_id = this.maintenancRec.delivery_technical_id
      this.maintenancRec.change_date = this.maintenancRec.delivery_date
      this.$forceUpdate()
    },
    // =======================================================================
    async saveItemData () {
      this.validationItemErrors = []
      let isError = false

      // ----------------------
      // Delivery Validation
      // ----------------------
      if (
        (this.maintenancRec.delivery_date && !this.maintenancRec.delivery_technical_id) ||
        (!this.maintenancRec.delivery_date && this.maintenancRec.delivery_technical_id)
      ) {
        this.validationItemErrors.push('يجب إدخال الفني وتاريخ التسليم معاً')
        isError = true
      }

      // ----------------------
      // Change Validation
      // ----------------------
      if (
        (this.maintenancRec.change_date && !this.maintenancRec.technical_id) ||
        (!this.maintenancRec.change_date && this.maintenancRec.technical_id)
      ) {
        this.validationItemErrors.push('يجب إدخال الفني وتاريخ التغيير معاً')
        isError = true
      }

      if (isError === true) {
        return
      }
      this.validationItemErrors = ''
      // ----------------------
      // Convert Empty To NULL
      // ----------------------
      this.maintenancRec.delivery_date =
        this.maintenancRec.delivery_date
          ? moment(this.maintenancRec.delivery_date).format('YYYY-MM-DD')
          : null

      this.maintenancRec.delivery_technical_id =
        this.maintenancRec.delivery_technical_id || null

      this.maintenancRec.change_date =
        this.maintenancRec.change_date
          ? moment(this.maintenancRec.change_date).format('YYYY-MM-DD')
          : null

      this.maintenancRec.technical_id =
        this.maintenancRec.technical_id || null

      this.maintenancRec.notes =
        this.maintenancRec.notes || null

      try {
        this.isLoadingData = true
        const data = await API.saveCustomerOfferItem(this.maintenancRec)
        const i = this.maintenancRecords.findIndex(x => x.id === data.id)
        if (i > -1) this.$set(this.maintenancRecords, i, data)

        const r = this.contract_offers.findIndex(x => x.id === this.record.id)
        if (r > -1) this.$set(this.contract_offers[r].items, i, data)
        Swal.fire({
          position: 'fixed',
          icon: 'success',
          title: 'تم الحفظ بنجاح',
          showConfirmButton: false,
          timer: 1000
        })
      } catch (err) {
        this.validationErrors = err.errors
      }
      this.isLoadingData = false
    },
    /*
|--------------------------------------------------------------------------
| *** delete offer Contract ***********
|--------------------------------------------------------------------------
*/
    deleteData (rec) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingData = true
          axios.post(this.$apiURL + 'deleteContractOffers', {
            token: localStorage.getItem('token'),
            id: rec.id,
            contract_id: rec.contract_id
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف السجل بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              let i = this.contract_offers.map(record => record.id).indexOf(rec.id)
              this.contract_offers.splice(i, 1)
              this.record = this.contract_offers[0]
              this.changeCustomerOffer(this.record)
              this.isLoadingData = false
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.validationErrors = err.response.data.errors
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Customers/Offers.vue